

































import { Component, Vue } from 'vue-property-decorator'
import { NoCache } from '@/decorators'
import { Action, Getter } from 'vuex-class'

import PageTitle from '@/components/PageTitle.vue'
import { Voucher } from '@/services/models'

import { formatters } from '@/helpers/components-utils'
import EditVoucherModal from '../components/EditVoucherModal.vue'

@Component({
  components: {
    PageTitle,
    EditVoucherModal,
  },
})
export default class Vouchers extends Vue {

  @Getter('firestore/vouchers')
  private items!: Voucher[]

  @Action('firestore/fetchVouchers')
  private fetchVouchers!: () => Promise<Voucher[]>

  private get fields(): Array<string|any> {
    return [
      { key: 'id', label: 'ID' },
      { key: 'name', label: 'NAME' },
      { key: 'customer.name', label: 'CUSTOMER' },
      { key: 'totalAmount', class: 'text-right', label: 'TOTAL', formatter: formatters.decimal },
      { key: 'issueDate', class: 'text-center', label: 'ISSUED', formatter: formatters.relativeDateTime },
      { key: 'actions', label: 'ACTIONS' },
    ]
  }

  public mounted() {
    this.fetchVouchers()
  }

  @NoCache
  public get editingVoucherModal(): EditVoucherModal {
    return this.$refs.editingVoucherModal as EditVoucherModal
  }

  public onVoucherCommitted() {
    //
  }
}
